import React, { useEffect, useState } from 'react';
import { BackButton, PageTitle } from '../ui';
import { RadioGroup } from '../ui/Radio';
import CarInfoCard from './carInfoCard';
import { useInView } from 'react-intersection-observer';
import { useGetCars } from '../../hooks/react-query/useCarData';

const AssignCarView = ({
  selectedDriver,
  handleCarSelect,
  handleBackClick,
}) => {
  const [searchTerm, setSearchTeram] = useState('');
  const { ref, inView } = useInView({ threshold: 0.4, child: true });

  const {
    data: carList,
    hasNextPage,
    fetchNextPage,
    isLoading,
  } = useGetCars(searchTerm, selectedDriver.id);
  const { id, firstName = '', lastName = '' } = selectedDriver || {};

  const subTitle = `Επίλεξε το αυτοκίνητο που θέλεις να προσθέσεις στον/στην ${firstName} ${lastName}`;

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, hasNextPage]);

  return (
    <>
      <div className="flex flex-col lg:gap-6 gap-3 lg:pb-6 pb-3">
        <BackButton text="Επιστροφή στο My Drivers" handleBackClick={handleBackClick} />
        <PageTitle
          title={<h2>Προσθήκη Αυτοκινήτου</h2>}
          subTitle={subTitle}
          wrapperClassName="justify-between"
          className="flex-[3_3_0%]"
          searchClassName="lg:flex-1 lg:self-end"
          handleSearch={(value) => setSearchTeram(value)}
        />
      </div>
      <RadioGroup
        className="grid lg:grid-cols-3 gap-3 pb-10"
        onValueChange={(value) => {
          const foundItem = carList?.pages.find(item => item.data?.some(car => car.plateno === value));
          if (foundItem) {
            const itemInsideData = foundItem.data.find(car => car.plateno === value);
            handleCarSelect({ plateno: value, name: itemInsideData.MakeName + ' ' + itemInsideData.ModelName })
          }
        }}
      >
        {carList?.pages.map((page) =>
          page.data?.map((carData, index) => {
            if (page.data.length >= 3 && page.data.length - 3 === index) {
              return (
                <CarInfoCard
                  carRef={ref}
                  carData={carData}
                  driverId={id}
                  key={carData.plateno}
                />
              );
            }
            return (
              <CarInfoCard
                carData={carData}
                driverId={id}
                key={carData.plateno}
              />
            );
          })
        )}
      </RadioGroup>
    </>
  );
};

export default AssignCarView;
